import React, { useState, useEffect, useRef, useCallback } from "react";
import Button from "../Button";
import modalClose from "../../img/icons/Close-m-grey.svg";
import "./style.css";
import localization from "../../data/config";
import { removeFilter } from "../../utilities/removeFilter";
import { useSelector } from "react-redux";
import MediaQuery from "react-responsive";
import breakpoints from "../../constants/breakpoints";
let prevFocusableElement;

/**
 * @name AlertModal
 * @function
 * @description Displays AlertModal for each column
 * @returns {JSX}
 * @param {*} props
 */
const AlertModal = () => {
  const modalState = useSelector((state) => state.modal);
  const [dontAskAgainChecked, setDontAskAgainChecked] = useState(false);
  const [isFilterRemoveChecked, setIsRemoveFilterChecked] = useState(false);
  const alertModalRef = useRef();

  

  //function to handle the check state of the remove filter checkbox
  const handleFilterCheckboxChange = () => {
    setIsRemoveFilterChecked(!isFilterRemoveChecked);
  };

  /**
   * @name handleConfirm
   * @function
   * @const
   * @description Function to handle Confirm button and store user preference in local storage
   */
  const handleConfirm = () => {
    if (isFilterRemoveChecked) {
      removeFilter(modalState.confirmState);
    }
    setDontAskAgainChecked(false);
    setIsRemoveFilterChecked(false);
    modalState.onConfirm(dontAskAgainChecked, modalState.confirmState);
  };

  /**
   * @name handleCancel
   * @function
   * @const
   * @description Function to handle cancel button in alert modal
   */
  const handleCancel = useCallback(() => {
    modalState.onCancel();
    setDontAskAgainChecked(false);
    setIsRemoveFilterChecked(false);
    if(prevFocusableElement){
      prevFocusableElement.focus();
    }
  });
  /**
   * @name handleKeyPress
   * @function
   * @const
   * @description Function to handle key pressed by user
   */
  const handleKeyPress = useCallback((event) => {
    const modalElement = alertModalRef.current;
    const focusableElements = Array.from(modalElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    let currentFocus = null;
    if (event.key === "Tab") {
      //If "Tab + Shift"
      if (event.shiftKey) {
        //If it's in the first element inside the modal, goes back to the last
        if (document.activeElement === firstElement) {
            lastElement.focus();
            event.preventDefault();
        }
      }
      //If "Tab"
      else {
            //Case for the first "tab" inside modal - focus the first element and saves the button that triggers the modal
            if(!focusableElements.includes(event.target)){
               firstElement.focus();
               prevFocusableElement = event.target;
               event.preventDefault();
            }
            //If focus is on last element, then returns to the first
            if (document.activeElement === lastElement) {
              firstElement.focus();
              event.preventDefault();
            }
        }
      currentFocus = document.activeElement;

    }
    if (event.key === "Escape") {
      handleCancel();
      event.preventDefault();
      //Focusing on the button that triggered the modal
      if(prevFocusableElement){
        prevFocusableElement.focus();
      }
      else{
        document.activeElement.focus()
      }
    }
  });

  useEffect(() => {
    if (modalState.isOpen) {
      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }
  }, [modalState.isOpen, handleCancel, handleKeyPress]);
  
  return !modalState.isOpen ? (
    <></>
  ) : (
    <>
    <MediaQuery minDeviceWidth={breakpoints.laptop.min}>
    <div className="modal-overlay">
      <div className="modal-content" ref={alertModalRef} role="alertdialog" aria-modal="true"aria-labelledby={modalState.modalTitle} aria-describedby={modalState.modalMessage}>
        <div className="modal-content__header">
          <div className="header__content">
            {!modalState.modalIcon ? (
              <></>
            ) : (
              <img
                className="modal-content__modalIcon"
                src={modalState.modalIcon}
                alt="Hide Columns"
              />
            )}
            <div className="header__content__title">
              {modalState.modalTitle ? modalState.modalTitle : ""}
            </div>
          </div>
          <img
            src={modalClose}
            alt="close"
            role="button"
            className="header__close"
            onClick={handleCancel}
            tabIndex={0}
          />
        </div>
        <div className="modal-content__message">
          <div className="modal-content__message__title">
            {modalState.modalMessage ? modalState.modalMessage : ""}
          </div>
          {!modalState.haveFilter ? (
            <></>
          ) : (
                    <div className="modal-content__filter-check">
                      <input
                        type="checkbox"
                        className="filter-check checkbox-global__input"
                        checked={isFilterRemoveChecked}
                        onChange={handleFilterCheckboxChange}
                        id="filterRemoveCheckbox"
                        aria-label={localization.removeFilter}
                        tabIndex={0}
                      />
                      <label htmlFor="filterRemoveCheckbox">
                        <p>{localization.removeFilter}</p>
                      </label>
                    </div>
          )}
        </div>
        {!modalState.haveActions ? (
          <></>
        ) : (
          
          <div className="modal-content__buttons">
            {!modalState.haveDontAskAgain ? (
              <div>{}</div>
            ) : (
                        <div className="modal-content__re-check">
                          <input
                            type="checkbox"
                            className="re-check checkbox-global__input"
                            checked={dontAskAgainChecked}
                            onChange={(e) => setDontAskAgainChecked(e.target.checked)}
                            id="dontAskAgainCheckbox"
                            tabIndex={0}
                          />
                          <label htmlFor="dontAskAgainCheckbox">
                            <span aria-hidden="true" className="sr-only">
                              {localization.dontAskMeAgain}
                            </span>
                            <span className="modal-content__re-check__text">{localization.dontAskMeAgain}</span>
                          </label>
                        </div>
            )}
            <div className="modal-content__action-buttons">
              <Button
                className="secondary_btn"
                onClick={handleCancel}
                value={localization.cancel}
                tabIndex={0}
              />
              <Button
                className="primary_btn"
                onClick={handleConfirm}
                tabIndex={0}
                value={
                  modalState.modalConfirmMessage
                    ? modalState.modalConfirmMessage
                    : localization.onConfirm
                }
              />
            </div>
          </div>
          
        )}
      </div>
    </div>
    </MediaQuery>

<MediaQuery maxDeviceWidth={breakpoints.mobile.max}>
<div className="modal-overlay" ref={alertModalRef}>
  <div className="modal-content-mobile">
    <div className="modal-content__header-mobile">
      <div className="header__content-mobile">
        {!modalState.modalIcon ? (
          <></>
        ) : (
          <img
            className="modal-content__modalIcon"
            src={modalState.modalIcon}
            alt="Hide Columns"
          />
        )}
        <div className="header__content__title-mobile">
          {modalState.modalTitle ? modalState.modalTitle : ""}

        </div>
        <img
            src={modalClose}
            alt="close"
            className="header__close-mobile"
            onClick={handleCancel}
            tabIndex={0}
          />
      </div>
    </div>
    <div className="modal-content__message-mobile">
      <div className="modal-content__message__title-mobile">
        {modalState.modalMessage ? modalState.modalMessage : ""}
      </div>
      {!modalState.haveFilter ? (
        <></>
      ) : (
        <div className="modal-content__filter-check">
          <input
            type="checkbox"
            className="filter-check checkbox-global__input"
            checked={isFilterRemoveChecked}
            onChange={handleFilterCheckboxChange}
            tabIndex={0}
          />
          <p>{localization.removeFilter}</p>
        </div>
      )}
    </div>
    {!modalState.haveActions ? (
      <></>
    ) : (
      <>
      <div className="modal-content__dontaskagain-mobile">
      {!modalState.haveDontAskAgain ? (
          <div>{}</div>
        ) : (
          <div className="modal-content__re-check-mobile">
            <input
              type="checkbox"
              className="re-check checkbox-global__input"
              checked={dontAskAgainChecked}
              onChange={(e) => setDontAskAgainChecked(e.target.checked)}
              tabIndex={0}
            />
            <p className="modal-content__re-check__text-mobile">{localization.dontAskMeAgain}</p>
          </div>
        )}
        </div>
      <div className="modal-content__buttons-mobile">

        <div className="modal-content__action-buttons">
          <Button
            className="secondary_btn"
            onClick={handleCancel}
            value={localization.cancel}
            tabIndex={0}
          />
          <Button
            className="primary_btn"
            onClick={handleConfirm}
            tabIndex={0}
            value={
              modalState.modalConfirmMessage
                ? modalState.modalConfirmMessage
                : localization.onConfirm
            }
          />
        </div>
      </div>
      </>
    )}
  </div>
</div>
</MediaQuery>
</>
  );
};

export default AlertModal;